import * as angular from "angular";
import template from "./view-mode-action.html";
import type { ViewModesModeController } from "./view-modes-mode";
import type { ViewModeActionDefinition } from "./view-modes-section-types";

export interface ViewModeActionController extends ViewModeActionDefinition {
	mode: ViewModesModeController;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class ViewModeActionController {
	public $onInit(): void {
		this.mode.registerAction(this);
	}
}

export default angular
	.module("vesl.components.view-modes-section.action", [])
	.component("viewModeAction", {
		template,
		controller: ViewModeActionController,
		bindings: {
			code: "@",
			label: "@",
			icon: "@?",
			iconOnly: "<?",
			intent: "@?",
			targetMode: "@?",
			visible: "<?",
			disabled: "<?",
			onInvoke: "&?"
		},
		require: {
			mode: "^^viewModesMode"
		}
	})
	.name;
